var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 68 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5072 0H12.4373C5.52766 0 0 5.52766 0 12.4373V15.0859H67.9445V12.4373C67.9445 5.52766 62.4169 0 55.5072 0ZM0 21.8804V39.6151C0 46.5247 5.52766 52.0524 12.4373 52.0524H55.5072C62.4169 52.0524 67.9445 46.5247 67.9445 39.6151V21.8804H0ZM32.8207 36.9665H14.7405C12.8979 36.9665 11.2857 35.4694 11.2857 33.5116C11.2857 31.5539 12.7827 30.0568 14.7405 30.0568H32.8207C34.6632 30.0568 36.2755 31.5539 36.2755 33.5116C36.2755 35.4693 34.7784 36.9665 32.8207 36.9665Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.c38374ee83060c1e63abcea9603aac43.svg";
export { ForwardRef as ReactComponent };